import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyD7l1hiMNWzY00XLMgSX0hPXiJuNdTI-Lw",
    authDomain: "guestlinkup.firebaseapp.com",
    projectId: "guestlinkup",
    storageBucket: "guestlinkup.firebasestorage.app",
    messagingSenderId: "587478390570",
    appId: "1:587478390570:web:d6d3824d87a6ca18fe7053",
    measurementId: "G-QHB0LJFRKG"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
